module.exports = "/packs/media/images/icons/icon_conversation-8d88e9627027936cf1af6dd633b69174.png";